var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin2 = function SvgMapPin2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 11.958a5.334 5.334 0 1 1 4.32-9.18 5.333 5.333 0 0 1-2.987 9.18v1.383c2.63.061 4.667.482 4.667.992 0 .552-2.388 1-5.334 1-2.945 0-5.333-.448-5.333-1 0-.51 2.036-.93 4.667-.992v-1.383Zm.666-1.292a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM8 8a1.333 1.333 0 1 1 0-2.667A1.333 1.333 0 0 1 8 8Z",
    fill: "#999FB4"
  })));
};
export default SvgMapPin2;